<div *ngIf="homeConfig"
     class="mt-2">
    <div class="flex justify-content-end m-3">
        <p-splitButton [label]="homeConfig?.id ? 'Save' : 'Add'"
                       icon="pi pi-check"
                       (onClick)="saveEntity()"
                       [model]="items">
        </p-splitButton>
    </div>
    <div class=" card p-fluid">
        <div class="grid">
            <div class="col-3">
                <div class="field">
                    <label for="name">Name:</label>
                    <input pInputText
                           id="name"
                           type="text"
                           [(ngModel)]="homeConfig.name"/>
                </div>
            </div>
            <div class="col-3">
                <div class="field">
                    <label for="name">Type:</label>
                    <p-dropdown [options]="typeOptions"
                                [(ngModel)]="homeConfig.type"></p-dropdown>
                </div>
            </div>
            <div class="col-3">
                <div class="field">
                    <label for="name">Name:</label>
                    <p-dropdown [options]="liveOptions"
                                [(ngModel)]="homeConfig.live"></p-dropdown>
                </div>
            </div>
            <div class="col-3">
                <div class="field">
                    <label for="note">Note:</label>
                    <textarea pInputTextarea
                              id="note"
                              [(ngModel)]="homeConfig.note"></textarea>
                </div>
            </div>
        </div>
    </div>

    <p-fieldset legend="Sections Overview"
                [toggleable]="true"
                [collapsed]="false"
                class="m-3">
        <p-orderList [value]="homeConfig.sections"
                     controlsPosition="right"
                     [listStyle]="{'max-height':'25rem'}"
        >
            <ng-template let-section
                         pTemplate="item"
                         let-i="index">
                <div class="grid">
                    <div class="col-9">
                        <app-section-view [section]="section"></app-section-view>
                    </div>
                    <div class="col-3 text-right z-5">
                        <button type="button"
                                pButton
                                icon="pi pi-pencil"
                                (click)="openEditDialog(section, i)"
                                class="p-button-info p-button-sm p-button-outlined"></button>
                        <button type="button"
                                pButton
                                icon="pi pi-trash"
                                class="p-button-danger p-button-sm p-button-outlined mx-2"
                                (confirmDelete)="deleteItem(i)"></button>
                        <button type="button"
                                pButton
                                icon="pi pi-download"
                                (click)="saveToFile(section)"
                                class="p-button-secondary p-button-sm p-button-outlined mr-2"></button>
                    </div>
                </div>
            </ng-template>
        </p-orderList>
    </p-fieldset>

    <section class="flex justify-content-center gap-3">
        <p-card class="w-5">
            <div class="grid">
                <div class="col-6 text-right">
                    <p-dropdown #newSectionType
                                [options]="selectTypes"
                                placeholder="Select Type">
                    </p-dropdown>
                </div>
                <div class="col-6">
                    <button type="button"
                            pButton
                            label="Add new section"
                            class="p-button-outlined"
                            (click)="addNewSection(newSectionType.value)"
                            [disabled]="!newSectionType.value">
                    </button>
                </div>
            </div>
        </p-card>

        <p-card class="w-5">
            <div class="grid">
                <div class="col-6">
                    <input type="file"
                           pInputText
                           (change)="handleFileInput($event)">
                </div>
                <div class="col-6">
                    <button type="button"
                            pButton
                            label="Import section"
                            class="p-button-outlined"
                            (click)="addNewSectionFromFile()"
                            [disabled]="!fileContent"></button>
                </div>
            </div>
        </p-card>
    </section>

    <br>
    <app-json-viewer [model]="homeConfig"></app-json-viewer>
</div>

